const $ = window.jQuery

const $inject = ['$compile','$window']

function NewsInspector(compile, window) {
    return {
        restrict: 'A',
        link: function(scope, elem, attrs) {
            scope._youtube = {
                ids: [],
                playerWidth: '100%',
                playerHeight: '300px'
            };

            setTimeout(init, 0);

            scope.$on('$ionicView.beforeLeave', function() {
                scope.$broadcast('$destroy');
            });

            function init() {
                let youtube = elem.find('iframe[src*="youtube"]'),
                    ruutu = elem.find('iframe[src*="ruutu"]'),
                    survey = elem.find('a[href*="survey"]'),
                    a = elem.find('a'),
                    columnParents = elem.find('.row.two-column,.row.three-column'),
                    columns = elem.find('.row.two-column > div[class^="col-"],.row.three-column > div[class^="col-"]');

                elem.find('.glyphicon').remove();
                
                columnParents.each((i, column) => {
                    column.className = 'col-xs-12'
                })

                columns.each((i, column) => {
                    column.className = ''
                })

                a.each((i, a) => {
                    let href = $(a).attr('href'),
                        isEmail = typeof href !== 'undefined' ? href.indexOf('mailto') >= 0 : false,
                        isPhone = typeof href !== 'undefined' ? href.indexOf('tel') >= 0 : false,
                        toSystem = isEmail || isPhone ? ',"_system"' : '';

                    $(a).attr(
                        'ng-click',
                        'openUrl("[url]"[extra])'
                            .replace('[url]', href)
                            .replace('[extra]', toSystem)
                    ).removeAttr('href');
                })

                survey.each((i, s) => {
                    console.log(s)
                    let url = $(s).attr('ng-click'),
                        hash = url.match(/survey=(.+)[&*|"*]/) || [],
                        button = $('<button/>')
                                    .addClass('button button-positive icon-left ion-ios-paper-outline')
                                    .attr('ng-click','openSurvey(\'[x]\')'.replace('[x]', hash[1]))
                                    .text($(s).text());
                                    
                    $(s).replaceWith(button);
                })

                youtube.each((i, iframe) => {
                    let youtube_id = iframe.src.split(/embed\/(.*?)\?/g)[1],
                        newElem = $('<youtube-video/>')
                                    .attr('video-id', '_youtube.ids[x]'.replace('x', i))
                                    .attr('player-width', '_youtube.playerWidth')
                                    .attr('player-height', '_youtube.playerHeight');
                                
                    scope._youtube.ids.push(youtube_id);
                    $(iframe).replaceWith(newElem);
                })

                ruutu.each((i, iframe) => {
                    let height = (9/16) * window.innerWidth;

                    $(iframe).css('height',(height + 10)+'px')
                })

                compile(elem.contents())(scope);
                scope.$apply();
            }
        }
    }   
}

NewsInspector.$inject = $inject

export default NewsInspector